
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class FranchiseePaymentsGrid extends Serenity.EntityGrid<FranchiseePaymentsRow, any> {
        protected getColumnsKey() { return FranchiseePaymentsColumns.columnsKey; }
        protected getDialogType() { return FranchiseePaymentsDialog; }
        protected getIdProperty() { return FranchiseePaymentsRow.idProperty; }
        protected getInsertPermission() { return FranchiseePaymentsRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseePaymentsRow.localTextPrefix; }
        protected getService() { return FranchiseePaymentsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}